
module.exports = function identity(value) {
    return value;
};



//////////////////
// WEBPACK FOOTER
// ../~/markup-it/lib/utils/identity.js
// module id = 803
// module chunks = 0